import AddGSTAdminPartial from "../../../../partials/admin/menus/vendors/add-gst-slider.admin.partial";

export default function AddGSTAdminScreen() {
  return <AddGSTAdminPartial />;
}
